<template>
  <v-dialog v-model="isOpenPrint" persistent max-width="200px">
    <div class="position-relative">
      <v-card>
        <v-card-text>
          <span class="modal-title font-weight-bold">
            <a class="btn-link" href="javascript:;" @click="printNebaSlip">{{ translations('shipping_instruction.unified_slip_printing') }}<i class="fas fa-external-link-alt"></i></a>
          </span>
          <button type="button" class="close" data-dismiss="modal" @click="close">
            &times;
          </button>
          <hr>
          <span class="modal-title font-weight-bold">
            <a class="btn-link" href="javascript:;" @click="openDeliverySlip" >{{ translations('shipping_instruction.pdf_slip_output') }}<i class="fas fa-external-link-alt"></i></a>
          </span>
        </v-card-text>
      </v-card>
      <loading-component :is-loading="isLoading"/>
    </div>
  </v-dialog>
</template>

<script>
import LoadingComponent from './loading/LoadingComponent.vue'
import _isEmpty from 'lodash/isEmpty'
import { mapState } from 'vuex'

export default {
  name: 'ShippingFilesModal',
  props: {
    isOpenPrint: {
      type: Boolean,
      default: false
    },
    shippingSelected: {
    }
  },
  components: {
    LoadingComponent
  },
  watch: {
    shippingSelected: {
      handler: function (val) {
        this.shipping = val
      },
      deep: true
    }
  },
  data () {
    return {
      isLoading: false,
      shipping: []
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    printNebaSlip () {
      if (!this.shipping.length) {
        this.$toastr.error(this.translations('shipping_instruction.notice_select_print'))
        return
      }
      this.isLoading = true
      let ordersId = this.shipping.map(shipping => [shipping.orders_id, shipping.id, shipping.details, shipping.shipping_at, shipping.is_user_warehouse_send_temp])
      this.$http.post(this.$api_url.orders_neba, { orders_id: ordersId, shippingInstruction: true }).then(response => {
        const result = response.data
        if (result.status || result.slip) {
          const arrBuff = this.b64ToArrayBuffer(result.slip.replace('data:application/pdf;base64,', ''))
          const deliveryFile = new Blob([arrBuff], { type: 'application/pdf' })
          const deliveryFileURL = URL.createObjectURL(deliveryFile)
          window.open(deliveryFileURL)
          URL.revokeObjectURL(deliveryFileURL)
        } else {
          this.$toastr.error(result.message)
        }
      }).catch(() => {
        this.$toastr.error(this.translations('shipping_instruction.notice_failed'))
      }).finally(() => {
        this.isLoading = false
      })
    },
    async openDeliverySlip () {
      if (!this.shipping.length) {
        this.$toastr.error(this.translations('shipping_instruction.notice_select_print'))
        return
      }
      this.isLoading = true
      let ordersId = this.shipping.map(shipping => [shipping.orders_id, shipping.id, shipping.details, shipping.shipping_at, shipping.is_user_warehouse_send_temp])
      await this.$http.post(this.$api_url.orders_delivery_slip, { orders_id: ordersId, shippingInstruction: true }).then(response => {
        const result = response.data
        if (result.status || result.slip) {
          const arrBuff = this.b64ToArrayBuffer(result.slip.replace('data:application/pdf;base64,', ''))
          const deliveryFile = new Blob([arrBuff], { type: 'application/pdf' })
          const deliveryFileURL = URL.createObjectURL(deliveryFile)
          window.open(deliveryFileURL)
        } else {
          console.log('ShippingInstruction:openDeliverySlip:status=false: ', result.message)
        }
      }).catch(error => {
        console.log('ShippingInstruction:openDeliverySlip:catch(error): ', error)
        this.$toastr.error(this.translations('shipping_instruction.notice_failed'))
      }).finally(() => {
        this.isLoading = false
      })
    },
    b64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      let len = binaryString.length
      let bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    close () {
      this.$emit('close', false)
    }
  }
}
</script>

<style scoped>

.position-relative {
  position: relative;
}
.close {
  position: absolute;
  top:5px;
  right: 10px;
}
</style>
